/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RouteDtoModel, RouteDtoModelType } from "./RouteDtoModel"
import { RouteDtoModelSelector } from "./RouteDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  route: RouteDtoModelType;
}

/**
 * RouteDriverUpdateDtoBase
 * auto generated base class for the model RouteDriverUpdateDtoModel.
 *
 * Schema to propagate changes on the driver assigned to a given route
 */
export const RouteDriverUpdateDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('RouteDriverUpdateDto')
  .props({
    __typename: types.optional(types.literal("RouteDriverUpdateDto"), "RouteDriverUpdateDto"),
    /** Payload to propagate changes on the driver assigned to a given route */
    route: types.union(types.undefined, MSTGQLRef(types.late((): any => RouteDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class RouteDriverUpdateDtoModelSelector extends QueryBuilder {
  route(builder: string | RouteDtoModelSelector | ((selector: RouteDtoModelSelector) => RouteDtoModelSelector) | undefined) { return this.__child(`route`, RouteDtoModelSelector, builder) }
}
export function selectFromRouteDriverUpdateDto() {
  return new RouteDriverUpdateDtoModelSelector()
}

export const routeDriverUpdateDtoModelPrimitives = selectFromRouteDriverUpdateDto()
